'use strict';

import {ListCtrl} from '../esfasi/listctrl.js';
import {reportItemModel} from "../../models/reportitemmodel.js";

export class ReportPreviewCtrl extends ListCtrl
{	
	storageNames = {
		query: ''
	};
	
	constructor($scope, $http, $filter, $timeout, $locale, jsDataService){
		super($scope, $http, $filter, $timeout, $locale, jsDataService);
		this.cfgExportUrl = this.jsDataService.get('cfgExportUrl', '');
		this.storageNames.query = this.jsDataService.get('cfgQueryStorageKey', '');
		
		if(this.classif.users){
			for(const user of this.classif.users) {
				user.title = `${user.name} ${user.lastname}`; 
			}
		}
	}
	
	setData(data){
		this.data = [];
		for(let ln of data){
			this.data.push(new reportItemModel(ln, this.$filter, this.jsDataService));
		}
	}
	
	getColValue(row, col){
		if(typeof(row[col]) === 'undefined'){
			return '';
		}
		if(row instanceof reportItemModel){
			return row.getValue(col);
		}
		return row[col];
	}
	
	exportList(){
		const query = new URLSearchParams({
			filters: JSON.stringify(this.query.filters),
			limit: this.query.limit,
			page: this.query.page,
		});
		
		const ts = new Date().toISOString().substring(0, 19).replace(/-|:|T/g, '');
		
		const a = document.createElement('a');
		a.style.display = 'none';
		a.href = `${this.cfgExportUrl}?${query.toString()}`;
		a.download = `Applications_report_${ts}.xlsx`;
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
	}
	
//	$onInit() {
//		
//	}
	
//	initQuery(){
//		
//	}
}